import React from 'react'

import StorfoxSaleOrderStatusField, { OPTIONS as BASE_OPTIONS } from '~/components/Fields/SaleOrderStatusField'

const OPTIONS = [{ value: '', name: 'All' }, ...BASE_OPTIONS]

function SupplierReturnStatusField (props) {
  return (
    <StorfoxSaleOrderStatusField
      name="status"
      label="Status"
      options={OPTIONS}
      {...props}
    />
  )
}

export default SupplierReturnStatusField
